import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import fieldGroups, { benefitLabels, metadatumFieldsDiffSet } from './criticalIllnessFields'

const defaultFields = {
  default: {
    values: [
      'hios_ids',
      'id',
      'vericred_id',
      'name',
      'audience',
      'issuer_name',
      'voluntary',
      'effective_date',
      'expiration_date',
      'privileged_data'
    ],
    pinned: ['id', 'vericred_id', 'sbc_url', 'sob_url']
  }
}

export default class CriticalIllnessBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={benefitLabels}
        metadatumFields={metadatumFieldsDiffSet}
        defaultFields={defaultFields}
        benefitsSetUrl="/critical_illness_benefits"
        productLine="critical_illness"
        fieldGroups={fieldGroups}
        includeSbcCheckbox
        sbcCheckboxLabel="Build from Benefit Summaries"
        hideSobUrl
        {...this.props}
      />
    )
  }
}
